export const RUBRIC_INFO = {
  DEFAULT_START_PAGE: 1,
  PAGE_SIZE: 20,
  PAGE: 'page'
};
